const React = require('react');
const App = require('./src/templates/App').default;
require('nodelist-foreach-polyfill');

const transitionDelay = 1;

exports.shouldUpdateScroll = () => false;

exports.onRouteUpdate = () => window.setTimeout(() => window.scrollTo(0, 0), transitionDelay);

exports.wrapPageElement = ({ element, props }) => {
    return <App {...props}>{element}</App>;
};
